let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Ghqb")).then(() => parcelRequire('e1Pao'));